import { Configuration, OrganizationsApi } from '@/api';
import CustomToast from '@/components/CustomToast';
import PageHeader from '@/components/PageHeader';
import { OrganizationCreate } from '@/models/Organization';
import Breadcrumbs from '@/modules/admin/components/Breadcrumbs';
import OrganizationForm from '@/modules/admin/components/OrganizationForm';
import { OrganizationListPath } from '@/modules/admin/paths';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const OrganizationAdd = () => {
  const navigate = useNavigate();
  const organizationsApi = new OrganizationsApi(new Configuration(useAuth));

  const handleOnSubmit = async (organization: OrganizationCreate): Promise<void> => {
    try {
      await organizationsApi.createOrganization(organization);

      toast.custom((t) => (
        <CustomToast
          id={t.id}
          message={`Organization "${organization.name}" created successfully!`}
          visible={t.visible}
        />
      ));

      navigate(OrganizationListPath);
    } catch (error) {
      console.error('Failed to create organization:', error);
    }
  };

  return (
    <>
      <Breadcrumbs />

      <PageHeader title="Create Organization" />

      <div className="w-full bg-white mx-auto rounded-lg shadow p-6 lg:p-12">
        <OrganizationForm onSubmit={handleOnSubmit} />
      </div>
    </>
  );
};

export default OrganizationAdd;
